import config from "../../config";
const baseUrl = config.baseUrl;

export const ServicesUrls = {

 SERVICES_ADD: baseUrl + "/service_galleries",
 SERVICES_EDIT: baseUrl + "/service_galleries",
 SERVICES_LIST: baseUrl + "/service_galleries",
 SERVICES_DELETE: baseUrl + "/service_galleries",
 SERVICES_GETBYID: baseUrl + "/service_galleries",
 SERVICES_ROLLBACK: baseUrl + "/service_galleries/rollback",
 SERVICES_DROPDOWN: baseUrl + "/service_galleries/dropdown",
 SERVICES_DELETE_HARD: baseUrl + "/service_galleries",

};
